import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Circle } from 'rc-progress';
import '../styles/ButtonLoader.css';
import Spinner from './Spinner/Spinner';

class ButtonLoader extends Component {
    renderIcon() {
        if (this.props.loading) {
            if (this.props.percent === 0) {
                return <Spinner spinColor={this.props.spinColor} spinAlignment={this.props.spinAlignment} />;
            }
            const style = {
                marginRight: '5px'
            };
            const circleSpanClass = 'ButtonLoader-circleSpan ButtonLoader-circleSpan-' + this.props.bsSize;
            return <span className={circleSpanClass} style={this.props.children ? style : null}><Circle percent={this.props.percent} strokeWidth="20" strokeLinecap="round" strokeColor='#FFFFFF' className='ButtonLoader-circle' /></span>;
        }

        return this.props.icon;
    }

    render() {
        const {
            bsStyle,
            bsSize,
            children,
            disabled,
            icon,
            loading,
            percent,
            spinColor,
            spinAlignment,
            ...other
        } = this.props;
        const buttonDisabled = disabled || loading;
        return (
            <Button bsStyle={bsStyle} bsSize={bsSize} {...other} disabled={buttonDisabled}>{this.renderIcon()} {children}</Button>
        );
    }
}

ButtonLoader.propTypes = {
    bsStyle: PropTypes.string,
    bsSize: PropTypes.oneOf(['xs', 'sm', 'lg']),
    children: PropTypes.node,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    loading: PropTypes.bool,
    percent: PropTypes.number,
    spinColor: PropTypes.string,
    spinAlignment: PropTypes.string
};

ButtonLoader.defaultProps = {
    bsStyle: 'default',
    children: null,
    disabled: false,
    icon: null,
    loading: false,
    percent: 0,
    spinColor: '#fff',
    spinAlignment: 'left'
};

export default ButtonLoader;